module.exports = __webpack_public_path__ + "static/media/mech1.d8279cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mech1.jpg
// module id = 5818
// module chunks = 0